"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const searcher_1 = require("./searcher");
const useSearcher = (possibleAnswers = []) => {
    const options = (0, react_1.useMemo)(() => (0, searcher_1.searcher)(possibleAnswers), [possibleAnswers]);
    const formatAnswers = answer => { var _a; return ({ label: (_a = answer.text) !== null && _a !== void 0 ? _a : answer.label, value: answer.value }); };
    const handleLoadOptions = val => {
        let optionsToLoad = possibleAnswers;
        if (typeof val === 'string' && val.length) {
            optionsToLoad = options.search(val).sort((a, b) => a.score - b.score);
        }
        return Promise.resolve(optionsToLoad.map(formatAnswers));
    };
    return { options, handleLoadOptions };
};
exports.default = useSearcher;
